import styled from "styled-components";

import { ContentStyles } from "./ContentStyles";

// If we need more than this in the future, consider unreset.css.
export const UnresetStyles = styled(ContentStyles)`
  & p {
    margin: 0.5em 0;
  }
`;
